import React from "react";
import { Modal } from "react-bootstrap";

export type PhoenixModalSize =
    | "sm"
    | "lg"
    | "xl"
    | "fullscreen"
    | "fullscreen-sm-down"
    | "fullscreen-md-down"
    | "fullscreen-lg-down"
    | "fullscreen-xl-down";

interface PhoenixModalProps {
    show: boolean;
    onHide: () => void;

    title?: string | React.ReactNode;
    children?: React.ReactNode;
    footer?: React.ReactNode;

    size?: PhoenixModalSize;
    centered?: boolean;
    backdrop?: "static" | true | false;
    keyboard?: boolean;

    closeButton?: boolean;

    bodyStyle?: React.CSSProperties;
    dialogClassName?: string;
    contentClassName?: string;
}

export function PhoenixModal({
    show,
    onHide,

    title,
    children,
    footer,

    size = "lg",
    centered = true,
    backdrop = "static",
    keyboard = true,
    closeButton = true,

    bodyStyle,
    dialogClassName,
    contentClassName,
}: PhoenixModalProps) {
    const reactBootstrapSize: "sm" | "lg" | "xl" | undefined =
        size === "sm" || size === "lg" || size === "xl" ? size : undefined;

    const fullscreenClass =
        size && size.startsWith("fullscreen") ? `modal-${size}` : "";

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered={centered}
            backdrop={backdrop}
            keyboard={keyboard}
            size={reactBootstrapSize}
            dialogClassName={`${dialogClassName ?? ""} ${fullscreenClass}`}
            contentClassName={contentClassName}
        >
            {title && (
                <Modal.Header closeButton={closeButton}>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}

            <Modal.Body style={bodyStyle}>{children}</Modal.Body>

            {footer && <Modal.Footer>{footer}</Modal.Footer>}
        </Modal>
    );
}

export default PhoenixModal;